import { axiosMock } from '@api/client';
import { API_URL } from '@api/apiDictionary';
import { createRandomFacilityList } from '../../mocks/facilities';

export const fetchFacilitiesMock = async () => {
    const data = createRandomFacilityList(20);
    return axiosMock.onGet(API_URL.facilities).reply(200, data);
};
